import * as React from 'react'
import { Button } from 'antd'
import { CreateProduct, CreateChildProduct } from '../ProductStore'
import { TagModels } from '@getgreenline/tags'
import { TagSelector } from './TagSelector'

interface TagsProps {
  companyId: number
  product: CreateProduct | CreateChildProduct
  tags: TagModels.ITagContract[]
  updateCreatedTagsContext?: (tagName: string, value: number, callback?: () => void) => void
}

export const Tags = (props: TagsProps) => {
  const [tagSelectorCount, setTagSelectorCount] = React.useState(0)
  // This uses a Map object to retain the insertion order
  const [tagSelectorValues, setTagSelectorValues] = React.useState<
    Map<string, string | null | undefined>
  >(
    // Produce the TagSelectors for the product's current tags
    props.product.tags
      ?.filter((tag) => 'deleteDate' in tag && !tag.deleteDate) // Filter out deleted tags
      .reduce((map, tag, i) => {
        map.set(-(i + 1), tag.name)
        return map
      }, new Map()) || new Map(),
  )
  const isTagSelected = (tagName: string) =>
    Array.from(tagSelectorValues.values()).includes(tagName)
  const setTagStatus = (selectorKey: string, value: string | null | undefined) => {
    if (value !== undefined) {
      tagSelectorValues.set(selectorKey, value)
    } else {
      tagSelectorValues.delete(selectorKey)
    }

    const newTagSelectorEntries = [...tagSelectorValues]
    const newTagSelectorValues = newTagSelectorEntries.map(([k, v]) => v)
    setTagSelectorValues(new Map(newTagSelectorEntries))

    if (props.companyId) {
      const companyId = props.companyId
      const tags = newTagSelectorValues
        .filter((tagName) => tagName)
        .map((value) => ({
          name: value,
          companyId,
        })) as TagModels.ICreateTagContract[]

      // Set tags on product
      props.product.changed = true
      props.product.setTags(tags)
      props.product.networkObject.tags = tags
    }
  }
  const addTagSelector = () => {
    const newTagSelectorCount = tagSelectorCount + 1

    setTagSelectorCount(newTagSelectorCount)
    setTagSelectorValues((map) => {
      map.set(newTagSelectorCount.toString(), null)
      return map
    })
  }

  return (
    <div className='col-xs-12' style={{ minHeight: '30em' }}>
      <div>
        <Button icon='plus' onClick={addTagSelector}>
          Add tag
        </Button>
      </div>
      <div style={{ paddingTop: 20 }}>
        {[...tagSelectorValues].map(([tagSelectorId, tagName]) => (
          <TagSelector
            defaultValue={typeof tagName === 'string' ? tagName : ''}
            isTagSelected={isTagSelected}
            setTagStatus={setTagStatus}
            id={tagSelectorId}
            key={tagSelectorId}
            tags={props.tags}
            updateCreatedTagsContext={props.updateCreatedTagsContext}
          />
        ))}
      </div>
    </div>
  )
}
